import React from "react"

export default function({ orderData }) {
  const gateway = orderData.payment_gateway[0]
  return (
    <div className="payment-method-display space-between border-bottom">
      <div className="method-details">
        <div className="method-name">
          <span className="bold">Payment Method:</span>
          <span className="method-name bold">{gateway.gateway_name}</span>
        </div>
        {(gateway.payment_type === "bank" ||
          gateway.gateway_code === "GC" ||
          gateway.gateway_code === "PAYMP") &&
          (gateway.payment_type === "bank" ? (
            <BankGateway
              name={gateway.bank_account_name}
              number={gateway.bank_account_number}
              qr_code={gateway.qr_code}
            />
          ) : gateway.gateway_code === "GC" ? (
            <GCGateway number={gateway.mobile_country_code + gateway.mobile} />
          ) : (
            <PAYMPGateway
              number={gateway.mobile_country_code + gateway.mobile}
              qr_code={gateway.qr_code}
            />
          ))}
      </div>
    </div>
  )
}

function BankGateway({ name, number, qr_code }) {
  return (
    <div className={qr_code && qr_code !== "" ? "qr-code" : ""}>
      {qr_code && qr_code !== "" && <img src={qr_code} alt={qr_code} />}
      <div>
        <span className="method-label bold">Account Name</span>
        <span className="method-value">{name}</span>
        <span className="method-label bold">Account Number</span>
        <span className="method-value">{number}</span>
      </div>
    </div>
  )
}

function GCGateway({ number }) {
  return (
    <div>
      <span className="method-label bold">Mobile Number</span>
      <span className="method-value">{number}</span>
    </div>
  )
}

function PAYMPGateway({ number, qr_code }) {
  return (
    <div className="qr-code">
      {qr_code && qr_code !== "" && <img src={qr_code} alt={qr_code} />}
      <div>
        <span className="method-label bold">Mobile Number</span>
        <span className="method-value">{number}</span>
      </div>
    </div>
  )
}
